module.exports = __webpack_public_path__ + "img/stencil.2c4dedd1.jpg";